module.exports = [{
      plugin: require('../plugins/google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"G-5PNYNE2F5Q"},
    },{
      plugin: require('../plugins/google-tag-manager/gatsby-browser.js'),
      options: {"plugins":[],"containerId":"GTM-PXPWTW"},
    },{
      plugin: require('../plugins/eva-react-v2/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/ane-redirect/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
